export default {
    DO_NOT_RENT: 'companies/:company_id/do-not-rent/',
}